module.exports = __webpack_public_path__ + "img/no-avatar.4ef49838.svg";